import { Pipe, PipeTransform } from '@angular/core';
import { Session } from '../models/tracer.model';

@Pipe({
  name: 'getAgency',
})
export class GetAgencyPipe implements PipeTransform {
  transform(session: Session): string {
    const request = session?.requests?.[0];
    return request?.agency ?? '';
  }
}
